<div class="PGImportPreviewModal">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'pg-import-tree.import-preview' | locTranslate }}</h4>
        <button type="button" class="modal-close btn btn-link" (click)="dismissModal()">
                <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        @if(isLoading || isImporting) {
            <app-pg-loading [isOverlay]="isImporting"></app-pg-loading>
        }
        @else {
            <div class="container-fluid PGImportPreviewModal">
                <div class="row border-bottom pb-3 mb-3">
                    <div class="col-12 text-end small">
                        @if(lastModified != null) {
                            <div>
                                <span>{{ 'pg-import-tree.import-preview-last-modified' | locTranslate }}: </span>
                                <span>{{ lastModified | locFormat:'datetime' }}</span>
                            </div>
                        }
                        <div>
                            <span>{{ 'pg-import-tree.import-preview-last-imported' | locTranslate }}: </span>
                            @if(lastImported == null) {
                                <span class="text-muted">{{ 'pg-import-tree.import-preview-not-imported' | locTranslate }}</span>
                            }
                            @else {
                                <span>{{ lastImported | locFormat:'datetime' }}</span>
                            }
                        </div>
                    </div>
                </div>
                <div class="row">
                    @for(field of elementData; track field) {
                        <div class="col-12 {{ field.large ? '' : 'col-lg-6' }} pb-3">
                            <div class="pb-1">
                                <b>{{field.label}}</b>
                            </div>
                            <div class="PGImportPreviewModal-Field-Value">
                                @if(field.type == 'html') {
                                    <span [innerHTML]="field.value"></span>
                                }
                                @else if(field.type == 'image') {
                                    <img src="{{field.value}}"/>
                                }
                                @else if(field.type == 'location') {
                                    <span [innerHTML]="field.value | locFormat:'location'"></span>
                                }
                                @else if(field.type == 'timetable-dates') {
                                    <span [innerHTML]="formatAvailability(field.value)"></span> <!-- NB: non so perché con locFormat: 'timetable-dates' non funzionava-->
                                }
                                @else {
                                    {{field.value}}
                                }
                            </div>
                        </div>
                    }
                    </div>
            </div>
        }
    </div>
    @if(!isLoading) {
        <div class="modal-footer">
            @if(isModifiedSinceImport()) {
                <div class="me-3 text-warning">
                    <i class="fa-regular fa-circle-exclamation"></i>
                    <span class="ms-2">{{ 'pg-import-tree.import-preview-modified-since-import' | locTranslate }}</span>
                </div>
            }
            <button class="btn btn-primary" [disabled]="isImporting" (click)="previewImport()">{{ 'pg-import-tree.import' | locTranslate }}</button>
        </div>
    }
</div>
